import React, { useEffect, useState } from "react";
import Label from "../../../components/Label";
import BarChart from "../../../components/D3Charts/BarChart";
import { useDispatch, useSelector } from "react-redux";
import { getEntityStats } from "../../Admin/adminAction";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { apiURL } from "../../../app.config";
import axios from "axios";

function Overview({widgets={}}) {
  const [graphData, setGraphData] = useState({});

  const activeEntity = useSelector(
    (state) => state?.adminReducer?.activeEntity
  );
  const monthOnMonthStats = useSelector(
    (state) => state?.adminReducer?.monthOnMonthStats
  );
  const userType = useSelector((state) => state?.appReducer?.userType);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const getCategories = () => {
    if (userType === "admin" || userType === 'viewer') {
      const dutchMonthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ].map(t);

      let months = [];
      for (let i = 0; i < 6; i++) {
        const currentDate = dayjs().subtract(i, "month").endOf("month");
        const monthName = dutchMonthNames[currentDate.month()];
        months.unshift(`${monthName}-${currentDate.year()}`);
      }
      return months;
    }
    if (userType === "product_owner") {
      const data = [];
      for (const property in graphData) {
        data.push(property);
      }
      return data;
    }
  };

  const getData = () => {
    if (userType === "admin" || userType === 'viewer') {
      let data = Array(6).fill(0);
      let months = [];
      data.forEach((item, index) => {
        months.unshift({
          year: dayjs().subtract(index, "month").endOf("month").year(),
          month: dayjs().subtract(index, "month").endOf("month").month(),
          amount: 0,
        });
      });
      if (monthOnMonthStats?.length > 0) {
        months = months.map((item) => {
          let amount = 0;
          monthOnMonthStats?.forEach((element) => {
            if (
              element.year === item.year &&
              element.month === item.month + 1
            ) {
              amount = element.amount || 0;
              amount += element.offlineAmount || 0;
            }
          });
          item.amount = amount?.toFixed(2);
          return item;
        });
      }
      return months.map((item) => item.amount);
    }
    if (userType === "product_owner") {
      const data = [];
      for (const property in graphData) {
        data.push(graphData[property]);
      }
      return data;
    }
  };

  const getGraphData = async () => {
    try {
      const graphData = await axios.get(
        `${apiURL}owner/dashboard/payments-per-mosque`
      );
      setGraphData(graphData?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeEntity && activeEntity._id && (userType === "admin" || userType === 'viewer')) {
      dispatch(
        getEntityStats({
          entity_id: activeEntity._id,
        })
      );
    }
  }, [dispatch, activeEntity]);

  useEffect(() => {
    if (userType === "product_owner") {
      getGraphData();
    }
  }, [userType]);

  return (
    <div className={`${(userType === "admin" || userType === 'viewer') ? "col-md-7 col-lg-8" :"col-12 margin-20"}`}>
      <div className="overview-card">
        <Label variant="text1" className="overview-head">
          {(userType === "admin" || userType === 'viewer')? t("Overview"): t("Income Overview")}
        </Label>
        <Label variant="text5" color="#7E7E7E" className="overview-disc">
          {(userType === "admin" || userType === 'viewer')?t("Monthly Received Amount"):t("Total amount received over the years per mosque")}
        </Label>
        <div className="white_box" style={{ height: "100%" }}>
          <div className="" style={{ height: "100%" }}>
            <div style={{ height: "100%" }}>
              <BarChart
                xdim={780}
                ydim={400}
                margin={{ top: 0, bottom: 60, left: 0, right: 0 }}
                name={t("Amount")}
                data={getData()}
                categories={getCategories()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Overview;
